/**
 * Chat name label. Renders name + persistent badges:
 *  • Admin: animated multi-color gradient (existing behaviour)
 *  • Pre-Alpha veteran: golden badge visible in every chat channel
 * Both badges can appear together if the user is both admin and veteran.
 */
export default function ChatName({ name, isAdmin, isPreAlpha, colon = false }) {
  const badges = [];
  if (isAdmin) {
    badges.push(
      <span key="admin"
        data-testid="admin-badge"
        className="chat-admin-badge px-1 py-[1px] text-[8px] tracking-[0.25em] uppercase font-heading">
        Admin
      </span>
    );
  }
  if (isPreAlpha) {
    badges.push(
      <span key="pre-alpha"
        data-testid="pre-alpha-badge"
        className="chat-pre-alpha-badge px-1 py-[1px] text-[8px] tracking-[0.25em] uppercase font-heading">
        Pre-Alpha
      </span>
    );
  }
  const nameClass = isAdmin
    ? "chat-admin-name-text"
    : "font-heading text-[#E5C34A] tracking-wider";
  return (
    <span
      data-testid={isAdmin ? "chat-name-admin" : "chat-name"}
      className={`${isAdmin ? "chat-admin-name" : ""} font-heading tracking-wider inline-flex items-center gap-1`}
    >
      {badges}
      <span className={nameClass}>{name}{colon ? ":" : ""}</span>
    </span>
  );
}
